import { useState } from 'react'
import { K, mono } from '../lib/theme'
import { short } from '../lib/format'
import { signup, type Config } from '../lib/api'

/** The pre-launch block: what is real today, the early-access capture, and the
 *  contract address once there is one. The CA is served from the API so it can
 *  be set the minute the coin exists, without a redeploy. */
export function Signup({ cfg }: { cfg: Config | null }) {
  const [email, setEmail] = useState('')
  const [state, setState] = useState<'idle' | 'sending' | 'done' | 'error'>('idle')
  const [msg, setMsg] = useState('')
  const [copied, setCopied] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (state === 'sending') return
    setState('sending')
    try {
      const r = await signup(email)
      setMsg(r.alreadyOn ? 'Already on the list — you are set.' : 'On the list. One email when the feeds switch on.')
      setState('done')
    } catch (err) {
      setMsg(err instanceof Error ? err.message : 'Could not save that.')
      setState('error')
    }
  }

  async function copyCa() {
    if (!cfg?.ca) return
    try {
      await navigator.clipboard.writeText(cfg.ca)
      setCopied(true)
      setTimeout(() => setCopied(false), 1600)
    } catch { /* clipboard blocked — the full value is in the title attribute */ }
  }

  return (
    <div>
      {cfg?.ca && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 12px', alignItems: 'center', marginTop: 16, fontFamily: mono, fontSize: 12.5 }}>
          <span style={{ color: K.txt, fontWeight: 500, border: '1px solid rgba(238,242,255,.35)', padding: '2px 8px', borderRadius: 2 }}>{cfg.ticker}</span>
          <span style={{ color: K.dim, fontSize: 10.5, letterSpacing: '.06em' }}>CA</span>
          <span title={cfg.ca} style={{ color: K.txt, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 'min(60vw,440px)' }}>
            <span className="ob-ca-full">{cfg.ca}</span><span className="ob-ca-short">{short(cfg.ca, 10, 8)}</span>
          </span>
          <button onClick={copyCa} style={{ background: 'none', border: `1px solid rgba(154,163,199,.3)`, color: K.mut, padding: '1px 6px', borderRadius: 2, fontFamily: 'inherit', fontSize: 10.5, cursor: 'pointer' }}>
            {copied ? 'copied' : 'copy'}
          </button>
        </div>
      )}

      <div style={{ marginTop: 14, border: `1px solid ${K.line2}`, padding: '14px 16px', maxWidth: 560 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <span style={{ fontFamily: mono, fontSize: 10.5, letterSpacing: '.08em', color: K.bg, background: K.mut, padding: '2px 7px', fontWeight: 500 }}>PREVIEW</span>
          <span style={{ fontSize: 13, color: K.txt }}>Prices and premiums are live. Alerts, history and the public API open soon.</span>
        </div>

        {state !== 'done' && cfg?.signupOpen !== false && (
          <>
            <form onSubmit={submit} style={{ display: 'flex', gap: 6, marginTop: 12, flexWrap: 'wrap' }}>
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@domain.com" aria-label="Email for early access"
                style={{ flex: '1 1 200px', minWidth: 0, background: K.bg, border: `1px solid rgba(154,163,199,.35)`, color: K.txt, padding: '9px 12px', fontFamily: mono, fontSize: 13, borderRadius: 2, outline: 'none' }}
              />
              <button type="submit" disabled={state === 'sending'} style={{ background: K.txt, color: K.bg, border: `1px solid ${K.txt}`, padding: '9px 14px', borderRadius: 2, fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap', cursor: state === 'sending' ? 'default' : 'pointer', opacity: state === 'sending' ? 0.6 : 1 }}>
                {state === 'sending' ? 'Sending…' : 'Request early access'}
              </button>
            </form>
            <div style={{ marginTop: 8, fontSize: 11.5, color: K.dim, lineHeight: 1.5 }}>
              One email when the live feeds switch on. No newsletter, nothing to buy.
            </div>
            {state === 'error' && <div style={{ marginTop: 8, fontSize: 12.5, color: K.am, fontFamily: mono }}>{msg}</div>}
          </>
        )}

        {state === 'done' && (
          <div style={{ marginTop: 12, fontFamily: mono, fontSize: 12.5, color: K.txt, display: 'flex', gap: 10, alignItems: 'center' }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: K.cy }} />{msg}
          </div>
        )}
      </div>
    </div>
  )
}
